/**
 * Created by henian.xu on 2023/6/12.
 *
 */
import Vue, { VueConstructor } from 'vue';

export function create$$t(vue: VueConstructor) {
    const old$t = vue.prototype.$t;
    const { $i18n } = vue.prototype;
    return function func(this: any, key: string, defaultValue: string, ...values: any[]): string {
        let res = '';
        if (old$t) {
            res = old$t.call(this, key, ...values);
        } else if ($i18n) {
            res = $i18n._t(key, $i18n.locale, $i18n._getMessages(), this, ...values);
        }
        return res || defaultValue || '';
    };
}
export const $$t = create$$t(Vue);

export default (vue: VueConstructor) => {
    vue.prototype.$$t = create$$t(vue);
};
